import { FC } from 'react';
import { PageTitle, PageLink } from '../../../_metronic/layout/core';
import { View } from './components/View';
import { useParams } from 'react-router-dom';
import { decryptId } from '../../../_metronic/helpers';

const NoteCollaboratorsPage: FC = () => {
  const { id_colaborador, id } =
    useParams<{ id_colaborador: string; id: string }>();

  const noteId = decryptId(id);
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Colaboradores',
      path: '/recursos_humanos/colaboradores/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Editar',
      path: `/recursos_humanos/colaboradores/edit/${id_colaborador}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: 'Notas',
      path: `/recursos_humanos/colaboradores/edit/${id_colaborador}`,
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>
        {noteId ? 'Editar nota' : 'Nueva nota'}
      </PageTitle>

      <View id={noteId ? noteId : '0'} />
    </>
  );
};

export { NoteCollaboratorsPage };
